export const routes = {
  stocks: {
    path: "/stocks",
    name: "stocks",
  },
  editStock: {
    path: "stocks/:id/edit/",
    name: "editStock",
  },
  createStock: {
    path: "/stocks/create",
    name: "createStock",
  },
  itemsStock: {
    path: "/items-stock",
    name: "itemsStock",
  },
  editItemsStock: {
    path: "items-stock/:id/edit/",
    name: "editItemsStock",
  },
  checkinWarehouse: {
    path: "/warehouse/checkin",
    name: "checkinWarehouse",
  },
  confirmationCheckin: {
    path: "/warehouse/confirmation-checkin/:itemId?",
    name: "confirmationCheckin",
  },
};
